import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "downloadSurveysButton" }
const _hoisted_2 = {
  id: "popoverTrigger",
  class: "downloadSurveysButtonContent px-4 py-1.5"
}
const _hoisted_3 = { class: "label text-sm font-medium" }
const _hoisted_4 = { class: "icon flex" }
const _hoisted_5 = { class: "popoverContent" }

import { IonPopover, IonContent, IonIcon } from '@ionic/vue'
import { ellipsisHorizontalCircle } from "ionicons/icons"
import { useI18n } from 'vue-i18n';

//Emits

export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadSurveysPopover',
  emits: ['downloadAll', 'downloadPlannedForToday', 'downloadFiltered'],
  setup(__props, { emit }) {



//Variables
const { t } = useI18n({ useScope: 'global' })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('downloadSurveysPopover.offlineDownload')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(IonIcon), {
          class: "md icon-small",
          icon: _unref(ellipsisHorizontalCircle)
        }, null, 8, ["icon"])
      ])
    ]),
    _createVNode(_unref(IonPopover), {
      trigger: "popoverTrigger",
      "trigger-action": "click",
      dismissOnSelect: true
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonContent), { class: "ion-padding" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "popoverItem py-4 text-base font-medium",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('downloadAll')))
              }, _toDisplayString(_unref(t)('downloadSurveysPopover.all')), 1),
              _createElementVNode("div", {
                class: "popoverItem py-4 text-base font-medium",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('downloadPlannedForToday')))
              }, _toDisplayString(_unref(t)('downloadSurveysPopover.plannedToday')), 1),
              _createElementVNode("div", {
                class: "popoverItem py-4 text-base font-medium",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('downloadFiltered')))
              }, _toDisplayString(_unref(t)('downloadSurveysPopover.filtered')), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})